export const STORAGE_KEY_SESSION= 'pomotion_session';

export type Session = {
  currentPomodoro: number;
  deskPosition: "sit" | "stand";
  lastUpdated: string;
}

export function loadSession(): Session{
	const session = localStorage.getItem(STORAGE_KEY_SESSION);
	if (!session) {
	  return freshSession();
	}

	const parsed: Session = JSON.parse(session);
	if (!isToday(parsed.lastUpdated)) {
	  return freshSession();
	}

	return parsed;
}

export function saveSession(session: Session) {
	localStorage.setItem(STORAGE_KEY_SESSION, JSON.stringify(session));
}

function freshSession(): Session {
  return {
	currentPomodoro: 0,
	deskPosition: "sit",
	lastUpdated: new Date().toISOString(),
  };
}

function isToday(dateString: string): boolean {
  const saved = new Date(dateString);
  const now = new Date();
  return saved.toDateString() === now.toDateString();
}
